<template>
  <b-modal v-model="model" centered modal-class="modal-bb-squared" hide-footer>
    <template slot="modal-header">
      <h5>Your job is saved in your dashboard</h5>
      <button class="close" @click="close"></button>
    </template>
    <template slot="default">
      <b-row class="pt-20 align-items-center">
        <b-col class="col-auto">
          <img
            class="img-fluid"
            :src="require('~/assets/img/ilustrations/group-3.svg')"
          />
        </b-col>
        <b-col class="fs20 fw500 pb-20">
          Sign up to get access to your dashboard where your applied and saved
          jobs live.
        </b-col>
      </b-row>

      <button class="btn btn-lg w-100 mt-40" @click="onSignUp">
        Take me to my dashboard
      </button>

      <div class="text-center fs14 py-20">
        Already have an account?
        <button class="btn btn-link" @click="onSignIn">Log in</button>
      </div>

      <div
        v-if="randomJobs && randomJobs.length"
        class="application-sent__related__wrapper"
      >
        <div class="py-20">
          <strong>Or see the similar jobs we found for you</strong>
        </div>
        <div v-for="item in randomJobs" :key="item.id" class="mb-16">
          <JobsListItem :job="item" :compact="true" :bordered="true" />
        </div>
        <n-link
          class="btn btn-outline btn-lg w-100 mt-40"
          to="/jobs"
          @click="close"
          >Find more similar jobs</n-link
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import JobsListItem from '@/components/jobs/JobsListItem'
import shuffle from 'lodash/shuffle'
import slice from 'lodash/slice'

export default {
  components: {
    JobsListItem
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    related: Array
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    randomJobs() {
      return slice(shuffle(this.related), 0, 3)
    }
  },
  methods: {
    onSignUp() {
      this.close()
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signup-landing',
        onCancel() {
          this.$store.dispatch('modal/cancel')
        }
      })
    },
    onSignIn() {
      this.close()
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signin',
        onCancel() {
          this.$store.dispatch('modal/cancel')
        }
      })
    },
    close() {
      this.model = false
    }
  }
}
</script>
<style scoped lang="scss">
.application-sent {
  &__related__wrapper {
    margin: 0 -3.125rem 0 -3.125rem;
    padding: 0 3.125rem;
    border-top: 1px solid #e8e9ea;
  }
}
</style>
